export default __webpack_public_path__ + "static/media/intro.7147dccd.jpg";